<template>
  <div>
    <div class="form-container oudonation ou-donation-form ncsysummer-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Select Your Gift Amount">
            <div>
              <AmountSelector amountText="Other Amount"/>
              <ErrorLabel field="amount" />

              <div class="sepecial__donate">* Donations of 180 and above will be listed on the site.</div>
            </div>
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <br />
            <InHonorOf />
            <br />
<FormRow>
              <FormLabel for="anonymousCheck">
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> I would like my donation to be listed anonymously.
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  onMounted,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  components: {},
  setup(props) {
    const { getValue, settings, setValue, form } = usePaymentForm();

    onMounted(() => {
      setValue('amount', '180');
    });
    // watch(
    //   () => getValue("custom.designation"),
    //   (val) => {
    //     if (val == "Relief" || !val) {
    //       setValue("applications.0.department", "NCSY_ReliefMissions");
    //       setValue("applications.0.campaign", "General Donation");
    //     } else {
    //       setValue("applications.0.department", "NCSY_Summer");
    //       setValue("applications.0.campaign", val);
    //     }
    //   }
    // );

    return {
      form,
      getValue,
      settings,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
::v-deep h2 {
  margin-bottom: 10px;
  margin-top: 20px;
  color: #000;
  font-weight: 700;
  font-size: 1.25em;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.ncsysummer-donation-form {
  max-width: 100%;
  overflow: hidden;
  box-shadow: none;
  padding: 0px;
  @media only screen and (min-width: 720px) {
    padding: 0px 0px;
    margin: 0px auto;
    max-width: 840px;
  }
}
// .ncsysummer-donation-form
//   ::v-deep
//   .styled-radio-container--ou-donation.styled-radio-container {
//   justify-content: center;

//   label {
//     border: 1px solid #0d346c;
//     color: #000000;
//     font-size: 15px;
//     &:hover {
//       background: #f7f7f7;
//     }
//   }
//   input[type="radio"]:checked + label {
//     background: #0d346c;
//   }
//   input[type="radio"]:checked + label .label-amount {
//     background: #0d346c;
//     border-color: #0d346c;
//   }
//   .label-description {
//     font-size: 16px;
//   }
//   .label-amount {
//     background: #0d346c;
//     color: white;
//   }
//   .radio-part {
//     min-width: 50%;
//     line-height: 20px;
//     max-width: 50%;
//   }
// }

.footer-links {
  text-align: center;
  font-size: 16px;
  margin: 50px auto 28px;
  line-height: 26px;
  color: #00346b;
  a {
    text-decoration: none;
  }
}
.footer-copyright {
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  color: #222;
  font-style: italic;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}

.frequency {
  margin-top: 20px;
}
// .teach-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation{
// 		.radio-part{
// 	  @media only screen and (min-width: 720px) {
// 			min-width: 50%;
// 			max-width: 50%;
// 		}
// 		}
// }

label {
  line-height: normal;
}
.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}

.doublepay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ncsysummer-donation-form ::v-deep .styled-radio--ou-donation.styled-radio label {
  font-size: 16px;
}
.ncsysummer-donation-form
  ::v-deep
  .styled-radio--ou-donation
  .amount_other__wrapper
  input[type="number"] {
  font-size: 16px;
}

.ncsysummer-donation-form
  ::v-deep
  .payment-info
  .styled-radio-container--ou-donation.styled-radio-container
  .radio-part {
  min-width: 50%;
  max-width: 50%;
}

::v-deep h2 {
  margin-bottom: 10px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
::v-deep hr {
  margin-bottom: 0px;
}

.ncsysummer-donation-form
  ::v-deep .styled-radio.styled-radio--ou-donation.row {
    .radio-part:first-of-type {
    position: relative;
    label::after {
    content: "*";
    z-index: 9;
        color: black;
}
 input[type=radio]:checked + label::after{
    content: "*";
    z-index: 9;
    color: white;
 }

  }

}
.sepecial__donate{
    padding-top: 5px;
    font-style: italic;
    font-size: 14px;
    line-height: normal;
}
ol, ul {
    margin-top: 0;
    font-size: 15px;
    padding-left: 0px;
    margin-bottom: 0px;
}
</style>
